import { render } from "./logotype.vue?vue&type=template&id=537e7148&scoped=true"
import script from "./logotype.vue?vue&type=script&lang=js"
export * from "./logotype.vue?vue&type=script&lang=js"

import "./logotype.vue?vue&type=style&index=0&id=537e7148&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537e7148"]])

export default __exports__